import "./fade-in.css.ts.vanilla.js";
var p = "kq227n1";
export { p as wrapper };
